<template>
  <div class="calling-container">
    <div class="phone-info">
      <div class="avatar-container">
        <img src="../../assets/logo.png" alt="logo">
      </div>
      <div v-show="unknownNumber" class="unknown-number-container">
        <div class="phone-number">{{this.incomingCallNumber? this.incomingCallNumber.uri.raw.user : ''}}</div>
      </div>
    </div>
    <div class="status-container">
      <div class="status" v-if="callState === state.RECEIVED">
        Cuộc gọi đến
      </div>
      <div v-if="callState === state.ANSWERED">
        {{ time | countime_up }}
      </div>
      <div v-if="callState === state.HANGUP">
        <b>{{time | countime_up}}</b> Kết thúc cuộc gọi
      </div>
    </div>
    <div class="call-actions">
      <button class="keypad-accept" @click="acceptAction()" v-if="callState !== state.ANSWERED">
        <i class="fa fa-phone" aria-hidden="true"></i>
      </button>
      <button class="keypad-decline" @click="declineAction()">
        <i class="fa fa-phone" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>

<script>
import ity from '../../lib/ity'
import {CALL_STATE} from '../../common/constant'
import callCenterAPI from '../../api/callCenter'
import sound from '../../assets/hangup.mp3'

export default {
  name: 'CallIn',
  props: {
    cancel: {
      type: Function,
      required: true
    },
  },
  data () {
    return {
      unknownNumber: true,
      time: 0,
      interval: null,
      state: CALL_STATE
    }
  },
  computed: {
    incomingCallNumber () {
      if (!ity.ua.session) return null
      return ity.ua.session.remoteIdentity
    },
    callState () {
      return ity.callState
    }
  },
  methods: {
    reset () {
      this.time = 0
      this.interval = null
    },
    acceptAction () {
      ity.ua.answer()
    },
    declineAction () {
      this.cancel()
      callCenterAPI.end_callin().then(res => {}).catch(() => {})
    },
    incrementTime () {
      this.time = parseInt(this.time) + 1
    },
  },
  watch: {
    callState: {
      handler: function () {
        if (this.callState === CALL_STATE.ANSWERED) {
          this.interval = setInterval(this.incrementTime, 1000)
        }
        if (this.callState === CALL_STATE.HANGUP) {
          clearInterval(this.interval)
          var audio = new Audio(sound)
          audio.play()
          setTimeout(() => {
            this.reset()
          }, 3000)
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.calling-container {
  width: 400px;
  padding-top: 20px;

  .phone-info {
    display: flex;
    flex-direction: row;
    margin: 20px;

    .avatar-container {
      img {
        height: 100px;
        width: 100px;
        border-radius: 100px;
      }

      margin-right: 20px;
    }

    .info-container {
      display: flex;
      flex-direction: column;

      .title {
        font-size: 24px;
        font-weight: bold;
      }

      .phone-number {
        font-size: 20px;
      }
    }

    .unknown-number-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 24px;
    }
  }

  .status-container {
    height: 215px;
    display: flex;
    justify-content: center;
    align-items: center;

    .status {
      font-weight: bold;
      animation: crescendo 1.5s alternate infinite ease-in;
    }

    @keyframes crescendo {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(1.3);
      }
    }
  }

  .call-actions {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 20px 0;

    .keypad-accept {
      height: 70px;
      width: 70px;
      margin: 5px;
      border-radius: 33px;
      font-size: 24px;
      background-color: #1b86d3;
      border: none;
      color: white;
    }

    .keypad-decline {
      height: 70px;
      width: 70px;
      margin: 5px;
      border-radius: 33px;
      font-size: 24px;
      background-color: #e14858;
      border: none;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/telephone/CallIn.vue